import React from "react"

// data
import services from "../../data/services"

const Services = () => {
  return (
    <section className="services" id="services">
      <div className="container">
        <header className="header service-header primary-header">
          <h1 className="main-heading">Our Services</h1>
        </header>
        <div className="showcase">
          {services.map((service) => (
            <article key={service.id}>
              <h3>0{service.id}</h3>
              <span>{service.icon}</span>
              <h2>{service.title}</h2>
              <p>{service.descr}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
